import { ChevronRight } from 'lucide-react'
import FindingCard from '@/frontend/features/Fde/investigations/FindingCard'
import type { InvestigationExecution, InvestigationFinding, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function AnalysisRecords({ findings, executions, copy, kind }: { findings: InvestigationFinding[]; executions: InvestigationExecution[]; copy: InvestigationLabels; kind: 'legacy' | 'unavailable' }) {
  if (findings.length === 0) return null
  return <section className="grid min-w-0 gap-3 border-t border-border pt-5">
    <details className="group/legacy min-w-0">
      <summary className="flex w-fit cursor-pointer list-none items-center gap-1.5 rounded-sm text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <ChevronRight className="size-3.5 transition-transform group-open/legacy:rotate-90" aria-hidden />{copy[`business_${kind}`]}<span className="text-xs tabular-nums text-muted-foreground">({findings.length})</span>
      </summary>
      <div className="mt-4 grid min-w-0 gap-3"><p className="text-xs leading-relaxed text-muted-foreground">{copy[`business_${kind}_notice`]}</p>{findings.map((finding) => <FindingCard key={finding.id} finding={finding} executions={executions} copy={copy} />)}</div>
    </details>
  </section>
}
